// Header/index.js
import { connect } from 'react-redux';

import CompaniesList from '../../components/CompaniesList';
import {
  fetchAllCompaniesDispatch,
  compayEditClickDispatch,
  openEditCompanyDialogDispatch,
  showDeleteOrDeactiveCompanyDialogStateChanged
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    companies:
      state.companies.allCompanies && state.companies.allCompanies.items
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAllCompanies: () => {
      dispatch(fetchAllCompaniesDispatch());
    },
    onCompanyEditClick: (company) => {
      dispatch(openEditCompanyDialogDispatch(true));
      dispatch(compayEditClickDispatch(company));
    },
    openDeleteOrDeactiveCompanyDialog: (open, companyId, status) => {
      dispatch(
        showDeleteOrDeactiveCompanyDialogStateChanged(open, companyId, status)
      );
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CompaniesList);
